import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NEW_SUMMARY_REPORT = {
    Id: 0,
    Name: "",
    Created: 0,
    ProjectId: 0
};
export const requiredFields = ["Name"];
export const NAMESPACE = "summaryReportEditor";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
